import React from 'react';

import './Einfuegungsdaempfung.css';
import { calculateInsertionLossValue, parseInsertionLossCsv } from '../calculations/insertionLoss';

class Einfuegungsdaempfung extends React.Component {
    constructor(props) {
    super(props);
    this.state = {
             daten: [],
             d32hz: 0,
             d63hz: 0,
             d125hz :0,
             d250hz :0,
             d500hz :0,
             d1000hz :0,
             d2000hz : 0,
             d4000hz : 0,
             d8000hz :0 ,
    };
    }

    // daten = [];
    // datastring = '';
    getDaten(Dname){
    //      console.log('Daten:');
    //    const request = await fetch('http://localhost:3000/testdaten.csv');
    //    //const request = await fetch('http://react.m2m-is.de/testdaten.csv');
    // const datastring = await request.text();
    //    console.log('Daten: ' + datastring.toString());
    //     let arr = datastring.split('\r');
    //     var jsonObj = [];
    //     var headers = arr[0].split(';');
    //     for(var i = 1; i < arr.length; i++) {
    //         var data = arr[i].split(';');
    //         var obj = {};
    //
    //         for(var j = 0; j < data.length; j++) {
    //             obj[headers[j].trim()] = data[j].trim();
    //         }
    //         jsonObj.push(obj);
    //     }
    //     JSON.stringify(jsonObj);
    //     console.log(jsonObj);
    //     console.log("Nr.: "+jsonObj[0]["125"]);
    //     this.datastring = datastring;
    //     var daten = [];
    //     daten = await this.csvJSON(datastring);
    //     this.setState({daten : daten});
    //     //this.daten = await this.csvJSON(datastring);
    //     console.log("D:" + daten);
        // console.log(daten[0]["Typ"]);

        //this.setState({Einfuegungsdaten: daten});
        // let da = []
        // //da = daten.find((x) => x['Typ'] === 'HKS' && x[125] < 2);
        // da = daten.filter((x) => x['Laenge'] >= 600 && x['Spalt'] >= 35);
        // let da1 = daten.sort((a,b) => a.Spalt - b.Spalt);
        // let daMin = daten.sort((a) => Math.min(a.Spalt))
        // let da2 = []
        // da2 = da.sort((a,b) => a.Spalt-b.Spalt);
        //
        // let xSoll = 35 //DS_Soll = Spaltbreite
        // let ySoll = 500 // KA_Soll = Kanallaenge
        //
        // let daten1 = daten.sort((a,b)=> a.Spalt - b.Spalt || a.Laenge - b.Laenge).find((x) => Math.min(x.Spalt) >=xSoll && Math.min(x.Laenge)  >= ySoll); //Min
        // let daten2 = daten.sort((a,b) => b.Laenge - a.Laenge || b.Spalt - a.Spalt).find((x) => Math.max(x.Spalt) <=xSoll && Math.max(x.Laenge) <= ySoll); //Max


        //
        // let deltaY = this.getDelta(daten1.Laenge, daten2.Laenge);
        //let deltaYSoll = this.getDelta(daten1.Laenge, daten2.Laenge);
        // console.log('delta ' +deltaY);
        //
        // // console.log('da');
        // // console.log(da);
        // // console.log('da1');
        // // console.log(da1);
        // // console.log('da2');
        // // console.log(da2);
        // console.log('daten1')
        // console.log(daten1);
        // console.log('daten2')
        // console.log(daten2);

        // var Xname = 'Spalt';
        // var Yname = 'Laenge';
        let daten = this.state.daten;
        let xSoll1 = parseFloat(this.props.Kulissenspalt); //DS_Soll = Spaltbreite
        let ySoll1 = parseFloat(this.props.Kulissenlaenge); // KA_Soll = Kanallaenge
        let musskriterium1 = this.props.Kulissentyp; //Vorfilterung => Kulissentyp
        let musskriterium2 = parseFloat(this.props.Kulissenbreite); //Vorfilterung => Kulissendicke
        // //
        //  console.log('ySoll1 ' + ySoll1);
        // console.log(daMin);
        // console.log("Kulissenspalt: "+ this.props.Kulissenspalt);

        let d = calculateInsertionLossValue({
            daten,
            Kulissenspalt: xSoll1,
            Kulissenlaenge: ySoll1,
            Kulissentyp: musskriterium1,
            Kulissenbreite: musskriterium2,
            Dname,
        });
        this.props.DaempfungsChange(Dname,d);
        //var d32 = this.getDeltaWert(daten ,xSoll1,ySoll1,Xname,Yname,'32');
        // var d63 = this.getDeltaWert(daten ,xSoll1,ySoll1,Xname,Yname,'63');
        // var d125 = this.getDeltaWert(daten ,xSoll1,ySoll1,Xname,Yname,'125');
        // var d250 = this.getDeltaWert(daten ,xSoll1,ySoll1,Xname,Yname,'250');
        // var d500 = this.getDeltaWert(daten ,xSoll1,ySoll1,Xname,Yname,'500');
        //
        // var d1000 = this.getDeltaWert(daten ,xSoll1,ySoll1,Xname,Yname,'1000');
        // var d2000 = this.getDeltaWert(daten ,xSoll1,ySoll1,Xname,Yname,'2000');
        // var d4000 = this.getDeltaWert(daten ,xSoll1,ySoll1,Xname,Yname,'4000');
        // var d8000 = this.getDeltaWert(daten ,xSoll1,ySoll1,Xname,Yname,'8000');

//        var d8000 = this.getDeltaWert()

        //this.setState({ d32hz: d32, d63hz: d63, d125hz:d125, d250hz: d250, d500hz: d500, d1000hz: d1000, d2000hz: d2000, d4000hz: d4000, d8000hz: d8000});
        return d;
    }

async componentDidMount(){

       const request = await fetch('../daten.csv');
       //const request = await fetch('http://react.m2m-is.de/testdaten.csv');
       const datastring = await request.text();

        this.datastring = datastring;
        let daten = parseInsertionLossCsv(datastring);
        //this.daten = await this.csvJSON(datastring);
        // console.log(daten[0]["Typ"]);
        this.setState({daten : daten});


  }


  getDelta(x,y){
      var delta = x-y;
      return delta;
  }

  getMinTuple(daten,XSoll,YSoll,Xname,Yname,Muss1,Muss2){
  //Ermittelt den min-Wert eines Arrays von Tuple
  // min = Tupel mit X < XSoll && Y < YSoll jedoch Höchstwerte nahe XSoll & YSoll
          let min = daten.filter((x) => String(x["Typ"]) === String(Muss1) && String(x["Dicke"]) === String(Muss2)).sort((a,b)=> a[Xname] - b[Xname] || a[Yname] - b[Yname]).find((x) => Math.min(x[Xname]) >=XSoll && Math.min(x[Yname]) >= YSoll);

      return min;
  }
  getMaxTuple(daten,XSoll,YSoll,Xname,Yname,Muss1,Muss2){
  //Ermittelt den max-Wert eines Arrays von Tuple
  // max = Tupel mit x > XSoll && Y > YSoll jedoch Niedrigwerte nahe XSoll & YSoll
      let max = daten.filter((x) => String(x["Typ"]) === String(Muss1) && String(x["Dicke"]) === String(Muss2)).sort((a,b) => b[Yname] - a[Yname] || b[Xname] - a[Xname]).find((x) => Math.max(x[Xname]) <=XSoll && Math.max(x[Yname]) <= YSoll);

      return max;
  }


  getDeltaWert(daten ,xSoll, ySoll,Xname,Yname,Dname,musskriterium1,musskriterium2){
        //Interpoliert die Datensätze min/max
        //XSoll/YSoll ist der gesucht Wert der sich auf Xname/YName bezieht
        //Dname gibt den den zu Interpolierenden wert an.

        //min = Tupel mit X < XSoll && Y < YSoll jedoch Höchstwerte nahe XSoll & YSoll
        //max = Tupel mit x > XSoll && Y > YSoll jedoch Niedrigwerte nahe XSoll & YSoll
        // Xname = 'Spalt'
        // Yname = 'Laenge'
        // Dname = '250'
        //console.log(Dname.toString());

        let XSoll = parseFloat(xSoll);
        let YSoll = parseFloat(ySoll);

       let min = this.getMinTuple(daten,XSoll,YSoll,Xname,Yname,musskriterium1,musskriterium2);
       let max = this.getMaxTuple(daten,XSoll,YSoll,Xname,Yname,musskriterium1,musskriterium2);
       if(min === undefined || max === undefined){

           return 0;

       }
       else {
           let deltaX = 0;
           let deltaXSoll = 0;
           let deltaY = 0;
           let deltaYSoll = 0;
           let deltaD = 0;
           let d1 = 0;
           let d = 0;


           // if (min !== undefined) {
           //     console.log("min: " + min);
           // }


           deltaX = this.getDelta(parseFloat(max[Xname]), parseFloat(min[Xname]));
           // console.log('deltaX');
           // console.log(deltaX);

           deltaXSoll = this.getDelta(parseFloat(XSoll), parseFloat(min[Xname]));
           // console.log('deltaXSoll');
           // console.log(deltaXSoll);
           // console.log(isNaN(deltaXSoll));

           deltaY = this.getDelta(parseFloat(max[Yname]), parseFloat(min[Yname]));
           // console.log('deltaY');
           // console.log(deltaY);
           // console.log(isNaN(deltaY));
           deltaYSoll = this.getDelta(parseFloat(YSoll), parseFloat(min[Yname]));
           // console.log('deltaYSoll');
           // console.log(deltaYSoll);

           deltaD = parseFloat(max[Dname]) - parseFloat(min[Dname]);
           // console.log('max[' + Dname + ']');
           // console.log(max[Dname]);

           // console.log('min[' + Dname + ']');
           // console.log(min[Dname]);
           //
           // console.log('deltaD');
           // console.log(deltaD);
           //
           // console.log((deltaXSoll / deltaX));

           d1 = parseFloat(min[Dname])
           // console.log('d1');
           // console.log(d1);

           // console.log(isNaN(Math.pow((deltaXSoll / deltaX),2)));
           // if(isNaN(Math.pow((deltaXSoll / deltaX),2))){
           //     console.log("DeltaXSoll / deltaX is NaN");
           // }
           // if(isNaN(Math.pow((deltaYSoll / deltaY) ? 0 : (deltaXSoll / deltaX), 2))){
           //     console.log("DeltaYSoll / deltaY is NaN");
           // }
           // //Wenn Delta d==0 dann nur d1 zurückgeben
           // if(deltaD == 0){
           //     console.log('d ' + Dname + ' hz: ' + d1);
           //     return d1; //
           // }
           //
           // d = d1 + deltaD * Math.sqrt((Math.pow((deltaXSoll / deltaX) ? 0 : (deltaXSoll / deltaX), 2) + Math.pow((deltaYSoll / deltaY) ? 0 : (deltaXSoll / deltaX), 2)));
           // console.log('d ' + Dname + ' hz: ' + d);
           // //console.log(d);

           //  console.log(isNaN(Math.pow((deltaXSoll / deltaX),2)));
           // if(isNaN(Math.pow((deltaXSoll / deltaX),2))){
           //     console.log("DeltaXSoll / deltaX is NaN");
           // }
           // if(isNaN(Math.pow((deltaYSoll / deltaY) ? 0 : (deltaXSoll / deltaX), 2))){
           //     console.log("DeltaYSoll / deltaY is NaN");
           // }
           //Wenn Delta d==0 dann nur d1 zurückgeben
           if(deltaD === 0){
               // console.log('d ' + Dname + ' hz: ' + d1);
               return d1; //
           }
           let deltaDIVX =0;
           if(isNaN((deltaXSoll / deltaX))){
               deltaDIVX = 0;
           }
           else {
               deltaDIVX = Math.pow((deltaXSoll / deltaX),2);
           }

           let deltaDIVY =0;
           if(isNaN((deltaYSoll / deltaY))){
               deltaDIVY = 0;
           }
           else {
               deltaDIVY = Math.pow((deltaYSoll / deltaY),2);
           }

            let calc = Math.sqrt( deltaDIVX + deltaDIVY);
           //d = d1 + deltaD * Math.sqrt((Math.pow( (deltaXSoll / deltaX)  ? 0 : (deltaXSoll / deltaX), 2) + Math.pow((deltaYSoll / deltaY) ? 0 : (deltaXSoll / deltaX), 2)));
            d = d1 + deltaD * calc;

           // console.log('d ' + Dname + ' hz: ' + d);
           //console.log(d);
           return d;
       }
  }

  csvJSON(csv){
        let arr = csv.split('\r');
        let jsonObj = [];
        let headers = arr[0].split(';');
        for(let i = 1; i < arr.length; i++) {
            let data = arr[i].split(';');
            let obj = {};

            for(let j = 0; j < data.length; j++) {
                obj[headers[j].trim()] = data[j].trim();
            }
            jsonObj.push(obj);
        }
        JSON.stringify(jsonObj);
        return jsonObj;
}



  render() {
        // console.log("Datenlänge: "+this.state.daten.length);

        // let hz32 =  this.getDaten("32").toFixed(2);
        let hz63 =  this.getDaten("63").toFixed(0);
        let hz125 =  this.getDaten("125").toFixed(0);
        let hz250 =  this.getDaten("250").toFixed(0);
        let hz500 =  this.getDaten("500").toFixed(0);
        let hz1000 =  this.getDaten("1000").toFixed(0);
        let hz2000 =  this.getDaten("2000").toFixed(0);
        let hz4000 =  this.getDaten("4000").toFixed(0);
        let hz8000 =  this.getDaten("8000").toFixed(0);

        return (
            <>
                 {/*<td>{this.getDeltaWert(this.props.Einfuegedaempfungsdaten ,xSoll,ySoll,Xname,Yname,'250')}</td>*/}
                 {/*<td className={this.props.Filter32hz > hz32 ? "filter" : "nofilter" }>{hz32}</td>*/}
                 <td className={this.props.Filter63hz > hz63 ? "filter" : "nofilter" }>{hz63}</td>
                 <td className={this.props.Filter125hz > hz125 ? "filter" : "nofilter" }>{hz125}</td>
                 <td className={this.props.Filter250hz > hz250 ? "filter" : "nofilter" }>{hz250}</td>
                 <td className={this.props.Filter500hz > hz500 ? "filter" : "nofilter" }>{hz500}</td>
                 <td className={this.props.Filter1000hz > hz1000 ? "filter" : "nofilter" }>{hz1000}</td>
                 <td className={this.props.Filter2000hz > hz2000 ? "filter" : "nofilter" }>{hz2000}</td>
                 <td className={this.props.Filter4000hz > hz4000 ? "filter" : "nofilter" }>{hz4000}</td>
                 <td className={this.props.Filter8000hz > hz8000 ? "filter" : "nofilter" }>{hz8000}</td>
                {/* <td className={soll > this.getDaten("32").toFixed(2) ? "filter" : "nofilter" }>{hz32}</td>*/}
                {/* <td  >{this.getDaten("63").toFixed(2)}</td>*/}
                {/*<td>{this.getDaten("125").toFixed(2)}</td>*/}
                {/*<td>{this.getDaten("250").toFixed(2)}</td>*/}
                {/*<td>{this.getDaten("500").toFixed(2)}</td>*/}
                {/*<td style={{backgroundColor: soll >= this.getDaten("1000").toFixed(2) ? 'red' : "white"}}>{hz1000}</td>*/}
                {/*<td>{this.getDaten("2000").toFixed(2)}</td>*/}
                {/* <td>{this.getDaten("4000").toFixed(2)}</td>*/}
                {/* <td>{this.getDaten("8000").toFixed(2)}</td>*/}
                 {/*<td>{this.state.d63hz.toFixed(2)}</td>*/}
                 {/*<td>{this.state.d125hz.toFixed(2)}</td>*/}
                 {/*<td>{this.state.d250hz.toFixed(2)}</td>*/}
                 {/*<td>{this.state.d500hz.toFixed(2)}</td>*/}
                 {/*<td>{this.state.d1000hz.toFixed(2)}</td>*/}
                 {/*<td>{this.state.d2000hz.toFixed(2)}</td>*/}
                 {/*<td>{this.state.d4000hz.toFixed(2)}</td>*/}
                 {/*<td>{this.state.d8000hz.toFixed(2)}</td>*/}
            </>
        );



  }
}
export default Einfuegungsdaempfung;
